import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button, Result } from "antd";

export const OrganizationNotFound = () => {
	const { logout } = useAuth0();

	const handleLogout = () => {
		logout({ returnTo: window.location.origin });
	};

	return (
		<Result
			status="404"
			title="404"
			subTitle="No podemos acceder a esta organización"
			extra={<Button type="primary" onClick={handleLogout} >Regresar</Button>}
		/>
	);
};
